import { MouseEvent, ReactNode } from "react";

import { classNames } from "~/utils/utils";

import "./style.less";

interface IButtonLink {
	title: ReactNode;
	onClick: () => void;
	disabled?: boolean;
	className?: string;
}

export default function ButtonLink({
	title,
	onClick,
	disabled = false,
	className = "",
}: IButtonLink) {
	function onLinkClick(event: MouseEvent) {
		event.stopPropagation();
		event.preventDefault();

		if (!disabled) {
			onClick();
		}
	}

	return <a href="#" className={classNames(["buttonLink", className])} onClick={event => onLinkClick(event)} data-disabled={disabled}>
		{title}
	</a>;
}
